import * as React from 'react';
import * as styles from './ServicesLayout.css';

interface IServicesLayoutProps {
  promotion: React.ReactNode;
  services: React.ReactNode;
  error: React.ReactNode;
}

export const ServicesLayout = ({ promotion, services, error }: IServicesLayoutProps) => {
  return (
    <div>
      {promotion && <div className={styles['promotion']}>{promotion}</div>}
      {services}
      <div className={styles['error']}>{error}</div>
    </div>
  );
};
